"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ColorPickerSolid: function() {
        return ColorPickerSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const ColorPickerSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M13.5 5.08584L12.7071 4.29295C12.3166 3.90243 11.6834 3.90243 11.2929 4.29295C10.9024 4.68348 10.9024 5.31664 11.2929 5.70716L12.0858 6.50006L4.1716 14.4143C3.42146 15.1644 3.00003 16.1818 3.00003 17.2427V17.764L1.1056 21.5528C0.913106 21.9378 0.98856 22.4028 1.29292 22.7072C1.59728 23.0115 2.06225 23.087 2.44724 22.8945L6.23609 21.0001H6.75739C7.81825 21.0001 8.83567 20.5786 9.58582 19.8285L17.5 11.9143L18.2929 12.7072C18.6834 13.0977 19.3166 13.0977 19.7071 12.7072C20.0977 12.3166 20.0977 11.6835 19.7071 11.293L18.9142 10.5001L21.7071 7.70717C23.2022 6.21207 23.2022 3.78805 21.7071 2.29295C20.212 0.797857 17.788 0.797858 16.2929 2.29295L13.5 5.08584ZM17.7071 3.70717C18.4212 2.99312 19.5789 2.99312 20.2929 3.70716C21.007 4.42121 21.007 5.57891 20.2929 6.29295L17.5 9.08584L14.9142 6.50006L17.7071 3.70717Z",
        fill: "currentColor"
    })
}), "ColorPickerSolid");
const _default = ColorPickerSolid;
